import { render, staticRenderFns } from "./ContinueWatchingCard.vue?vue&type=template&id=d20d3494&scoped=true"
import script from "./ContinueWatchingCard.vue?vue&type=script&lang=js"
export * from "./ContinueWatchingCard.vue?vue&type=script&lang=js"
import style0 from "./ContinueWatchingCard.vue?vue&type=style&index=0&id=d20d3494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20d3494",
  null
  
)

export default component.exports